{
  "wallet": {
    "title": "Wallet",
    "coins": "Coins",
    "coins_a11y": "{n} Coins",
    "statement": "Recent",
    "empty": "Nothing yet.",
    "error": "Your wallet did not load.",
    "retry": "Try again",
    "locker_back": "Welcome back. Your {n} Coins were kept in the locker while you were away. They are all here.",
    "loading": "Loading your wallet",
    "guest": "Your wallet opens when your game is saved.",
    "line_a11y": "{reason}, {amount} Coins, {date}"
  },
  "reason": {
    "starting_balance": "Starting Coins",
    "eng_checkin": "Daily check-in",
    "coach_fee": "Coach",
    "lesson_fee": "Extra lesson",
    "physio_fee": "Physio",
    "fitness_class": "Fitness",
    "mind_coach_fee": "Mind coach",
    "nutrition_plan": "Nutrition plan",
    "sleep_kit": "Sleep and travel kit",
    "extra_hours": "Extra golf hours",
    "camp_fee": "Training camp",
    "reversal": "Refund",
    "other": "Other"
  }
}
